import { getStateIndex } from '@/services/db/actions/utils/getStateIndex'

export const stateColors = {
  default: 'rgb(113, 128, 150)',
  optimal: 'rgb(0, 128, 0)',
  dismal: 'rgb(204, 0, 0)',
}

const calculateColorOfState = (
  stateIds: Array<string>,
  optimalStateId: string | null,
  stateId: string,
) => {
  if (!optimalStateId) {
    return stateColors.default
  }
  const index = getStateIndex(stateIds, stateId)
  const indexOfOptimalState = getStateIndex(stateIds, optimalStateId)

  if (index === indexOfOptimalState) {
    return stateColors.optimal
  }
  if (stateIds.length === 2) {
    return stateColors.dismal
  }
  const maxDistanceFromOptimal = Math.max(
    indexOfOptimalState,
    stateIds.length - indexOfOptimalState - 1,
  )
  const stateDistanceFromOptimal = Math.abs(index - indexOfOptimalState)

  const greenColorRatio = 1 - stateDistanceFromOptimal / maxDistanceFromOptimal
  const g = Math.round(0 + greenColorRatio * 204)

  return `rgb(204, ${g}, 0)`
}

export default calculateColorOfState
